import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { KPI } from '../api';

@Injectable()
export class ExportsService {

  constructor(
    private http: HttpClient,
  ) { }

  // export assets from the ag-grid table
  public downloadAssetsTableExport(params?: any) {
    const endpoint = `/decision/api/equipment/export/`
    return this.downloadExport(endpoint, true, params, "application/json")
  }

  // export investments from the ag-grid table
  public downloadInvestmentTableExport(params: any) {
    return this.downloadExport(`/decision/api/investments/export/`, true, params, "application/json")
  }

  // export initiative from the ag-grid table
  public downloadInitiativeTableExport(params: any) {
    return this.downloadExport(`/decision/api/initiatives/export/`, true, params, "application/json")
  }

  public downloadRisksExport(params?: any): Observable<void> {
    return this.downloadExport('/risks/export/', true, params, 'application/json');
  }

  public downloadMultiSiteExport(params?: any): Observable<void> {
    return this.downloadExport('/reporting/multisite-export/', true, params, 'application/json');
  }

  public downloadPurchaseFlowExport(params?: any): Observable<void> {
    return this.downloadExport('/purchase/api/export', true, params, 'application/json');
  }

  public downloadSkeletonImportExcel(params?: any): Observable<void> {
    return this.downloadExport('/import/api/skeleton-import-excel/', false, params);
  }

  public downloadUnimportedDataExcel(params?: any): Observable<void> {
    return this.downloadExport('/import/api/unimported-data/', true, params, 'application/json');
  }

  public investmentExportReady = new BehaviorSubject(false);
  public investmentExportLoading = new BehaviorSubject(false);

  public assetExportReady = new BehaviorSubject(false);
  public assetExportLoading = new BehaviorSubject(false);

  private downloadExport(
    endpoint: string,
    postParams: boolean = false,
    params?: any,
    contentType: 'application/x-www-form-urlencoded' | 'application/json' = 'application/x-www-form-urlencoded',
  ): Observable<void> {
    const method = postParams ? 'POST' : 'GET';
    let body = null;
    let headers = new HttpHeaders();

    if (postParams) {
      if (contentType === 'application/json') {
        headers = headers.set('Content-Type', 'application/json');
        body = params;
      } else {headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
        const param_helper = new URLSearchParams();
        for (const key in params) {
          if (key) {
            param_helper.set(key, params[key]);
          }
        }
        body = param_helper.toString();
      }
    }

    return this.http.request(
      method,
      `${environment.backendHost}${endpoint}`,
      {
        ...(body ? { body } : {}),
        ...(!postParams ? { params } : {}),
        responseType: 'blob',
        observe: 'response',
        headers: headers,
      },
    ).pipe(
      map((response) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        const fileName = contentDisposition ? contentDisposition.split('filename=')[1].replace(/"/g, '') : "file";

        const blob = new Blob([response.body], { type: response.headers.get('content-type') });

        const downloadURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadURL;
        a.download = fileName;
        a.click();

        return downloadURL;
      }),
      delay(100),
      map((downloadURL) => window.URL.revokeObjectURL(downloadURL)),
    );
  }

   /**
   * Actually go to download the export
   * @param options TExportPayload
   * @returns actually download an excel file using HTML API
   */
   public download_assets_excel_export(options: KPI.TExportPayload) {
    let {payload, columnDefs} = options
    const requestOptions = {
      columnDefs,
      ...payload
    }
    return this.downloadAssetsTableExport(requestOptions)
  }

   /**
   * Actually go to download the export
   * @param options TExportPayload
   * @returns actually download an excel file using HTML API
   */
   public download_investments_excel_export(options: KPI.TExportPayload) {
    const  {payload, columnDefs} = options;
    const requestOptions = {
      columnDefs,
      ...payload
    }
    return this.downloadInvestmentTableExport(requestOptions);
  }


  /**
   * Actually go to download the export
   * @param options TExportPayload
   * @returns actually download an excel file using HTML API
   */
  public download_initiatives_excel_export(options: KPI.TExportPayload) {
    const  {payload, columnDefs} = options;
    const requestOptions = {
      columnDefs,
      ...payload
    }
    return this.downloadInitiativeTableExport(requestOptions);
  }


}
